/*
 * Hello! This was built for a hackathon, so I've used way too many hacks. Please bear 🐻 with me
 */

import {
  BrowserRouter,
  Redirect,
  Route,
  Switch
} from "react-router-dom";

import Dashboard from "./pages/Dashboard";
import ProductDetails from "./pages/ProductDetails";
import PageNotFound from "./pages/PageNotFound";
import Home from "./pages/Home";

import './App.scss';

function App() {
  return (
    <div className="flex-row mobile-flex-column">
      <BrowserRouter>
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/dashboard" exact component={Dashboard} />
          <Route path="/product/:productId" exact component={ProductDetails} />
          <Route path="/product/:productId/epic/:epicId" exact component={ProductDetails} />
          <Route
            path="/"
            exact
            component={() => <Redirect to="/dashboard" replace />}
          />
          <Route path="*" component={PageNotFound} />
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default App;
